// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ModalCard_modalWrapper__Fvsl4"};